import axios from "axios";
import { clearToken, getToken } from "../utils/tokenStorage";

/**
 * Centralized Axios instance. Every API call in the app must go through this
 * client so base URL, auth header, timeout, and error handling stay in one
 * place (per the migration's "API client" requirement) instead of being
 * duplicated per component.
 */
const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api",
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

httpClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response ? error.response.status : null;

    if (status === 401) {
      // Token missing/expired/invalid: drop it and send the user back to login.
      clearToken();
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }

    if (status === 403) {
      // Authenticated but not permitted — let the caller decide how to show this
      // (e.g. an inline "you don't have permission" message), don't redirect.
    }

    if (error.code === "ECONNABORTED") {
      error.message = "The request timed out. Please try again.";
    }

    return Promise.reject(error);
  }
);

export default httpClient;
